// extracted by mini-css-extract-plugin
export var borderRadius = "_ar-4";
export var large = "_ar-3";
export var logoContainer = "_ar-0";
export var nameLogo = "_ar-2";
export var small = "_ar-1";